import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_481_13232)" }, [
      _createElementVNode("path", {
        d: "M0.152303 11.8771L21.2445 43.5904C21.4083 43.8498 21.695 44 22.009 44C22.323 44 22.596 43.8498 22.7735 43.5904L43.852 11.8771C44.0431 11.5904 44.0567 11.2082 43.8793 10.9078L37.7496 0.450512C37.5857 0.163823 37.2854 0 36.9578 0L7.0465 0C6.71886 0 6.41851 0.177474 6.25469 0.450512L0.125 10.8942C-0.0524747 11.1945 -0.0388228 11.5768 0.152303 11.8635V11.8771ZM28.1523 12.2867L22.9236 35.0171L22.9236 12.2867L28.1523 12.2867V12.2867ZM21.0806 35.1809L15.7018 12.2867L21.0806 12.2867L21.0806 35.1672V35.1809ZM30.0226 12.2867L41.3673 12.2867L24.0158 38.3891L30.0226 12.2867ZM21.927 2.70307L27.5107 10.4437L16.3434 10.4437L21.927 2.70307ZM14.555 9.7884L8.80759 1.82935L20.3025 1.82935L14.555 9.7884V9.7884ZM23.5653 1.82935L35.0465 1.82935L29.2991 9.7884L23.5653 1.82935ZM19.9475 38.3345L2.62329 12.2867L13.8315 12.2867L19.9475 38.3345ZM41.4902 10.4437L31.1011 10.4437L36.8212 2.49829L41.4765 10.4437H41.4902ZM7.11476 2.60751L12.7666 10.4437L2.51408 10.4437L7.11476 2.60751Z",
        fill: "black"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_481_13232" }, [
        _createElementVNode("rect", {
          width: "44",
          height: "44",
          fill: "white"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }